<template>
  <div>
    <el-card>
      <template #header>订单查询</template>
      <el-form :inline="true" @submit.prevent>
        <el-form-item label="用户ID">
          <el-input v-model.trim="query.user_id" placeholder="例如 1001" style="width: 140px" />
        </el-form-item>
        <el-form-item label="状态">
          <el-input v-model.trim="query.status" placeholder="active/paid/refund" style="width: 160px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="loadOrders">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button :disabled="orders.length === 0" @click="exportOrdersCsv">导出CSV</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="orders" stripe border v-loading="loading" size="small">
        <el-table-column prop="id" label="ID" width="90" />
        <el-table-column prop="user_id" label="用户ID" width="90" />
        <el-table-column prop="order_no" label="订单号" min-width="160" show-overflow-tooltip />
        <el-table-column prop="plan_code" label="套餐" width="130" />
        <el-table-column prop="status" label="状态" width="110" />
        <el-table-column prop="pay_channel" label="渠道" width="110" />
        <el-table-column prop="created_at" label="创建时间" min-width="160" />
      </el-table>
    </el-card>

    <el-card style="margin-top: 12px;">
      <template #header>客服补偿</template>
      <el-form label-width="110px" style="max-width: 560px;">
        <el-form-item label="用户ID">
          <el-input v-model.number="compForm.user_id" />
        </el-form-item>
        <el-form-item label="补偿类型">
          <el-radio-group v-model="compForm.type">
            <el-radio label="days">会员天数</el-radio>
            <el-radio label="times">免费次数</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="补偿值">
          <el-input-number v-model="compForm.value" :min="1" :max="365" />
        </el-form-item>
        <el-form-item label="补偿原因">
          <el-input v-model="compForm.reason" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="compLoading" @click="submitCompensate">提交补偿</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { adminApi } from '../api/admin'

const loading = ref(false)
const orders = ref([])
const query = reactive({ user_id: '', status: '' })

const compLoading = ref(false)
const compForm = reactive({ user_id: 0, type: 'days', value: 7, reason: '' })

async function loadOrders() {
  loading.value = true
  try {
    const data = await adminApi.orderList({
      page: 1,
      page_size: 30,
      user_id: query.user_id || undefined,
      status: query.status || undefined
    })
    orders.value = data.list || []
  } catch (e) {
    ElMessage.error(e.message || '加载订单失败')
  } finally {
    loading.value = false
  }
}

async function submitCompensate() {
  if (!compForm.user_id || !compForm.value) {
    ElMessage.warning('用户ID和补偿值必填')
    return
  }
  compLoading.value = true
  try {
    await adminApi.compensateSubscription(compForm)
    ElMessage.success('补偿成功')
    await loadOrders()
  } catch (e) {
    ElMessage.error(e.message || '补偿失败')
  } finally {
    compLoading.value = false
  }
}

function escapeCsv(value) {
  const text = value === null || value === undefined ? '' : String(value)
  if (text.includes(',') || text.includes('"') || text.includes('\n')) {
    return `"${text.replace(/"/g, '""')}"`
  }
  return text
}

function exportOrdersCsv() {
  if (!orders.value.length) {
    ElMessage.warning('暂无可导出的订单')
    return
  }
  const header = ['id', 'user_id', 'order_no', 'plan_code', 'status', 'pay_channel', 'created_at']
  const lines = [header.join(',')]
  for (const row of orders.value) {
    lines.push(
      [
        escapeCsv(row.id),
        escapeCsv(row.user_id),
        escapeCsv(row.order_no),
        escapeCsv(row.plan_code),
        escapeCsv(row.status),
        escapeCsv(row.pay_channel),
        escapeCsv(row.created_at)
      ].join(',')
    )
  }
  const csv = '\uFEFF' + lines.join('\n')
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `orders_${Date.now()}.csv`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
  ElMessage.success('订单CSV已导出')
}

onMounted(loadOrders)
</script>
